import React, { Component } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import SearchUser from './SearchUser';
import SearchNotFound from './SearchNotFound';
import SearchLoading from './SearchLoading';
import { SearchUsersListWrap } from './style';

class SearchUsersList extends Component {
    fetchMoreData = isLoadAll => {
        if (isLoadAll) return;
        setTimeout(() => this.props.handleScroll(), 500);
    };

    get body() {
        const { users, isLoadAll, handleClose } = this.props;
        return (
            <SearchUsersListWrap>
                <InfiniteScroll
                    dataLength={users.length}
                    next={() => this.fetchMoreData(isLoadAll)}
                    hasMore
                    loader={isLoadAll ? null : <SearchLoading />}
                    height={225}
                >
                    {users.map((user, index) => (
                        <SearchUser key={index} handleClose={handleClose} {...user} />
                    ))}
                </InfiniteScroll>
            </SearchUsersListWrap>
        );
    }

    render() {
        const { users, loading } = this.props;
        if (loading) return <SearchLoading />;
        if (users.length) return this.body;

        return <SearchNotFound />;
    }
}

export default SearchUsersList;



// WEBPACK FOOTER //
// ./src/UI/Containers/Search/SearchUsersList.js